export const Config = {
  production: true,
  ENV: 'PROD',
  API_VERSION: 21,
  WEBSERVICEURL: 'https://apitest.imzayeri.com/v1',
  WEBSERVICEURL_LEGACY: 'https://apitest1.imzayeri.com/v1',
  WEB_APP_URL: 'https://test.imzayeri.com',
  WEB_APP_URL_LEGACY: 'https://test1.imzayeri.com',
  WEBSITE: 'https://imzayeri.com',
  TITLE: 'ImzaYeri',
  LOGO: "https://test.imzayeri.com/assets/images/logo.png",
  IDENTITY_PROVIDER_LOGO: "https://test.imzayeri.com/assets/images/imzayeri_logo_mavi.png",
  PAGE_LIMIT: 50,
  GOOGLE_APP_SCRIPT_URL: "https://script.google.com/macros/d/11thWpH60r4tdu2J2xWmVg6aeSIpxo7Y3tN1M6cAJ_wXMD0xg7p6cBC3U/usercallback",
  PHONE_CODE_NUMBER:90,
  BILLING_COUNTRY:"TR",
  PAYMENT_METHOD:"IYZICO",
  ADYEN_CLIENT_KEY:"test_6SWWGLKL7VDA7BXRWYAWKJZIHIFDCY5N",
  STRIPE_PUBLISHABLE_KEY:"",
  WEB_CLIENT_ID:"42c14a2c-0114-4831-b57b-5a9b5749d749",
  UI_LOCALE:"tr",
  IDENTITY_PROVIDER:"GLUU",
  IDENTITY_PROVIDER_URL: 'https://identity.ilerian.com',
  LOGOUT_ENDPOINT: 'https://identity.ilerian.com/oxauth/restv1/end_session',
  TERMS_OF_USE_LINK:"https://imzayeri.com/kullanim-sartlari/",
  COMPANION_URL: "https://companion.imzayeri.com",
  GOOGLE_PICKER_API_KEY: "AIzaSyAQtuSGTV7pW-UV5hGmoVjye2-4jE455TY",
  GOOGLE_PICKER_CLIENT_ID: "346037438955-shr8ms3098nf4iqdo9uph8k2p5hadiv8.apps.googleusercontent.com",
  GOOGLE_PICKER_APP_ID: "346037438955",
  PLAUSIBLE_SCRIPT_URL: ''
};
